import { Link, mergeClasses } from "@fluentui/react-components";
import { useSharedPillButtonStyles } from "theme/sharedStyles";
import { AiReviewFilter } from "apps/project-iq/utils/aiReviewFilter";
import { useAiReviewFilterBarStyles } from "./AiReviewFilterBar.styles";
import { IAiReviewFilterBarProps } from "./AiReviewFilterBar.types";

const FILTER_GROUP_LABEL = "Filter by review status";
const ACCEPT_ALL_LABEL = "Accept all AI-drafted";

export const AiReviewFilterBar = ({
  activeFilter,
  needsReviewCount,
  onFilterChange,
  onAcceptAll,
  isAcceptingAll = false,
}: IAiReviewFilterBarProps): JSX.Element => {
  const styles = useAiReviewFilterBarStyles();
  const pillButtonStyles = useSharedPillButtonStyles();

  const filterOptions: { value: AiReviewFilter; label: string }[] = [
    { value: "all", label: "All" },
    {
      value: "needs_review",
      label:
        needsReviewCount > 0
          ? `Needs review (${needsReviewCount})`
          : "Needs review",
    },
    { value: "reviewed", label: "Reviewed" },
    { value: "manual", label: "Manual" },
  ];

  return (
    <div className={styles.root}>
      <div
        className={styles.filters}
        role="group"
        aria-label={FILTER_GROUP_LABEL}
      >
        {filterOptions.map((option) => {
          const isActive = activeFilter === option.value;
          return (
            <button
              key={option.value}
              type="button"
              className={mergeClasses(
                pillButtonStyles.pillButton,
                isActive && pillButtonStyles.pillButtonActive,
              )}
              aria-pressed={isActive}
              onClick={() => onFilterChange(option.value)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
      {needsReviewCount > 0 && (
        <Link
          as="button"
          className={styles.acceptAll}
          disabled={isAcceptingAll}
          onClick={onAcceptAll}
        >
          {`${ACCEPT_ALL_LABEL} (${needsReviewCount})`}
        </Link>
      )}
    </div>
  );
};
